import { makeStyles } from '@material-ui/core';
import React, { useState, useContext, useEffect } from 'react';
import { TrashIcon } from '../../../UI/Images/Icons';
import download from '../../../../assets/images/Icon/downloadIcon.svg';
import { PropTypes } from 'prop-types';
import { getFullDate } from '../../../../utils/dateTimeUtil';
import { AlertDialog, SubmitButton } from '../../../UI';
import MessagesContext from '../../../../contexts/messagesContext';
import { getSearchReport } from '../../../../redux/Search/SearchAction';
import { useDispatch } from 'react-redux';

const styles = makeStyles({
    container: {
        padding: '0 20px',
        minWidth: '600px'
    },
    header: {
        fontFamily: 'inherit',
        fontSize: '15px',
        fontWeight: 'bold',
        color: '#272333',
        marginBottom: '24px'
    },
    wrapper: {
        display: 'flex',
        flexDirection: 'column'
        // justifyContent: 'space-between'
        // alignItems: 'flex-start'
    },
    overallInfo: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px'
    },
    row: {
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        fontSize: '13px',
        color: '#232733',
        fontWeight: 'bold',
        marginBottom: '8px'
    },
    details: {
        fontSize: '12px',
        fontWeight: 'normal',
        color: '#989ea3',
        margin: '0 5px'
    },
    date: {
        borderRight: '1px solid #ced2d6',
        paddingInlineStart: '5px'
    },
    downloadLink: {
        color: '#509ffa',
        fontSize: '13px',
        fontFamily: 'inherit',
        fontWeight: 'bold',
        marginInlineEnd: '15px',
        marginInlineStart: '5px'
    },
    loadingButton: {
        height: '35px',
        width: '140px',
        borderRadius: '6px',
        border: '1.5px solid #509ffa',
        color: '#509ffa',
        background: '#fff'
    },
    buttonContainer: {
        display: 'flex',
        alignItems: 'center',
        '& > div': {
            marginInlineStart: '24px',
            width: '20px'
        },
        '& svg': {
            cursor: 'pointer'
        },
        '& button img': {
            marginInlineEnd: '6px'
        },
        '& button': {
            fontSize: '12px',
            fontWeight: 'bold'
        }
    },
    messageContainer: {
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
});

const Report = ({ item, handleDelete }) => {
    Report.propTypes = {
        item: PropTypes.object,
        handleDelete: PropTypes.function
    };
    const classes = styles();
    const { messages } = useContext(MessagesContext);

    const saveFile = (form) => {
        if (form?.export_file) {
            const a = window.document.createElement('a');
            a.href = form.export_file;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    };

    return (
        <div className={classes.overallInfo}>
            <div className={classes.detailWrapper}>
                <div className={classes.row}>
                    <span className={classes.details}>{messages.createdBy}</span>
                    <span>
                        {item?.export_creator?.first_name} {item?.export_creator?.last_name}{' '}
                    </span>
                    <span className={`${classes.details} ${classes.date}`}>
                        {getFullDate(item.export_requested_at)}{' '}
                    </span>
                </div>
            </div>
            <div className={classes.buttonContainer}>
                {item.export_status === 'D' ? (
                    <>
                        <button className={classes.loadingButton} disabled>
                            {messages.loadingMessage}...
                        </button>
                        <div />
                    </>
                ) : (
                    item.export_status === 'G' && (
                        <>
                            <SubmitButton
                                isButton
                                height="35px"
                                width="140"
                                handleClick={() => saveFile(item)}
                            >
                                <img src={download} alt="download" />
                                {messages.downloadReports}
                            </SubmitButton>
                            <div>
                                <TrashIcon onClick={() => handleDelete(item.id)} />
                            </div>
                        </>
                    )
                )}
            </div>
        </div>
    );
};

const DownloadReports = ({ reports, handleDeleteExport }) => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const [formName, setFormName] = useState('');
    const dispatch = useDispatch();

    const handleDelete = (formName) => {
        setFormName(formName);
    };
    useEffect(() => {
        dispatch(getSearchReport());
    }, []);

    return (
        <>
            <AlertDialog
                open={!!formName}
                alertText={messages.alerts.deleteExport}
                cancelText={messages.cancel}
                confirmText={messages.delete}
                handleAction={() => {
                    handleDeleteExport(formName);
                    setFormName('');
                }}
                handleClose={() => setFormName('')}
            />
            {!reports?.length ? (
                <div className={classes.container}>
                    <div className={classes.messageContainer}>
                        <span>{messages.noReportFound}</span>
                    </div>
                </div>
            ) : (
                <div className={classes.container}>
                    <h1 className={classes.header}>{messages.downloadReports}</h1>
                    <div className={classes.wrapper}>
                        {reports?.map((item, index) => (
                            <Report item={item} key={index} handleDelete={handleDelete} />
                        ))}
                    </div>
                </div>
            )}
        </>
    );
};
DownloadReports.propTypes = {
    handleDeleteExport: PropTypes.function,
    reports: PropTypes.array
};
export default DownloadReports;
